module.exports = require("core-js/library/fn/set-immediate");